import { useSetAtom } from 'jotai';
import React, { useCallback } from 'react';

import { Table } from '~/components/blocks';
import { settingsDrawerState } from '~/state/settings_systemsettings/atoms';

export const PrescriptionIdentify = () => {
  const set = useSetAtom(settingsDrawerState);

  const handleClick = useCallback(() => {
    set({ drawer: 'prescriptionIdentify' });
  }, [set]);

  return (
    <Table.Tr onClick={handleClick}>
      <Table.Td>処方箋読取設定</Table.Td>
    </Table.Tr>
  );
};
